import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private permissions: { [permission: string]: boolean } = {};

  constructor() {}

  PermissionDecline() {
    Swal.fire({
      text: 'Permission Denied',
      icon: 'error',
      buttonsStyling: false,
      confirmButtonText: 'Ok, got it!',
      customClass: {
        confirmButton: 'btn fw-bold btn-primary',
      },
    });
  }

  async setPermission(action: string, value: boolean) {
    this.permissions[action] = value;
  }

  hasPermission(action: string): boolean {
    return this.permissions[action];
  }

  //#region USER

  canViewUserList(): boolean {
    return this.hasPermission('read all user');
  }

  canViewOwnUserList(): boolean {
    return this.hasPermission('read own user');
  }

  canCreateUser(): boolean {
    return this.hasPermission('create user');
  }

  canEditUser(): boolean {
    return this.hasPermission('update all user');
  }

  canEditOwnUser(): boolean {
    return this.hasPermission('update own user');
  }

  canDeactivateUser(): boolean {
    return this.hasPermission('deactivate user');
  }

  canDeleteUser(): boolean {
    return this.hasPermission('delete user');
  }

  canAccessUserList(): boolean {
    return this.hasPermission('access user');
  }

  canHideUser(): boolean {
    return this.hasPermission('hide user');
  }

  //#region ROLE

  canViewRoleList(): boolean {
    return this.hasPermission('read role');
  }

  canCreateRole(): boolean {
    return this.hasPermission('create role');
  }

  canEditRole(): boolean {
    return this.hasPermission('update role');
  }

  canDeleteRole(): boolean {
    return this.hasPermission('delete role');
  }

  canAccessRoleList(): boolean {
    return this.hasPermission('access role');
  }

  canHideRole(): boolean {
    return this.hasPermission('hide role');
  }

  //#region CUSTOMER

  canViewCusList(): boolean {
    return this.hasPermission('read all customer');
  }

  canViewOwnCusList(): boolean {
    return this.hasPermission('read own customer');
  }

  canCreateCus(): boolean {
    return this.hasPermission('create customer');
  }

  canEditCus(): boolean {
    return this.hasPermission('update all customer');
  }

  canEditOwnCus(): boolean {
    return this.hasPermission('update all customer');
  }

  canDeactivateCus(): boolean {
    return this.hasPermission('deactivate customer');
  }

  canDeleteCus(): boolean {
    return this.hasPermission('delete customer');
  }

  canAccessCusList(): boolean {
    return this.hasPermission('access customer');
  }

  canShowPass(): boolean {
    return this.hasPermission('reset password customer');
  }

  canHideCustomer(): boolean {
    return this.hasPermission('hide customer');
  }

  //#region ORDER

  canViewOrderList(): boolean {
    return this.hasPermission('read all order');
  }

  canViewOwnOrderList(): boolean {
    return this.hasPermission('read own order');
  }

  canCreateOrder(): boolean {
    return this.hasPermission('create order');
  }

  canEditOrder(): boolean {
    return this.hasPermission('update all order');
  }

  canDeleteOrder(): boolean {
    return this.hasPermission('delete order');
  }

  canAccessOrderList(): boolean {
    return this.hasPermission('access order');
  }

  canHideOrder(): boolean {
    return this.hasPermission('hide order');
  }

  //#region LICENSE

  canViewLicenseList(): boolean {
    return this.hasPermission('read all license');
  }

  canViewOwnLicenseList(): boolean {
    return this.hasPermission('read own license');
  }

  canCreateLicense(): boolean {
    return this.hasPermission('create license');
  }

  canEditLicense(): boolean {
    return this.hasPermission('update all license');
  }

  canDeleteLicense(): boolean {
    return this.hasPermission('delete license');
  }

  canAccessLicenseList(): boolean {
    return this.hasPermission('access license');
  }

  canHideLicense(): boolean {
    return this.hasPermission('hide license');
  }

  //#region AUDIT

  canViewAllAudit(): boolean {
    return this.hasPermission('read all audit');
  }

  canViewOwnUserAudit(): boolean {
    return this.hasPermission('read own user audit');
  }

  canViewOwnCusAudit(): boolean {
    return this.hasPermission('read own user audit');
  }

  canAccessAudit(): boolean {
    return this.hasPermission('access audit');
  }

  canHideAudit(): boolean {
    return this.hasPermission('hide audit');
  }

  //#region SMARTLOCK V1
  canAccessSmartlockV1(): boolean {
    return this.hasPermission('access smart lock');
  }

  canHideSmartlockV1(): boolean {
    return this.hasPermission('hide smart lock');
  }

  //#region SMARTLOCK V2

  canAccessProfileSmartlock(): boolean {
    return this.hasPermission('profile access smart lock v2');
  }

  canAccessSmartlock(): boolean {
    return this.hasPermission('access smart lock v2');
  }

  canAccessLicense(): boolean {
    return this.hasPermission('license access smart lock v2');
  }

  canAccessUpgrading(): boolean {
    return this.hasPermission('upgrading access smart lock v2');
  }

  canAccessApproval(): boolean {
    return this.hasPermission('approval access smart lock v2');
  }

  canCreateSmartlock(): boolean {
    return this.hasPermission('create smart lock v2');
  }

  canApproveSmartlock(): boolean {
    return this.hasPermission('approve smart lock v2');
  }

  canRejectSmartlock(): boolean {
    return this.hasPermission('reject smart lock v2');
  }

  canReadOwnActivitySmartlock(): boolean {
    return this.hasPermission('read own activity smart lock v2');
  }

  canReadAllActivitySmartlock(): boolean {
    return this.hasPermission('read all activity smart lock v2');
  }

  canHideSmartlock(): boolean {
    return this.hasPermission('hide smart lock v2');
  }

  //#region SETTING

  canAccessSetting(): boolean {
    return this.hasPermission('access setting');
  }

  canViewSetting(): boolean {
    return this.hasPermission('read setting');
  }

  canEditSetting(): boolean {
    return this.hasPermission('update setting');
  }

    //#region NOTIFY_USER

    canAccessNotifyUser(): boolean {
      return this.hasPermission('access notify user');
    }
    
    canViewNotifyUserList(): boolean {
      return this.hasPermission('read notify user');
    }
  
    canCreateNotifyUser(): boolean {
      return this.hasPermission('create notify user');
    }
  
    canEditNotifyUser(): boolean {
      return this.hasPermission('update notify user');
    }

    //#region QUBE CONNECT

    canAccessQubeConnect(): boolean {
      return this.hasPermission('access qube connect');
    }

    canViewQubeConnect(): boolean {
      return this.hasPermission('read qube connect');
    }

    canEditQubeConnect(): boolean {
      return this.hasPermission('update qube connect');
    }
}
